import React from 'react'
import Lang from "@components/Lang/Lang"
import AutoFetchTable from "@/components/AutoFetchTable/AutoFetchTable";
import LogisticsAndCabinetSwitch from "@/components/Logistics/LogisticsAndCabinetSwitch";
import { Spin, Tooltip,} from 'antd'
import dayjs from 'dayjs';
import PageCommon from  "@components/PageCommon/PageCommon";
import { toFixedWithCommas} from "@utils/number-util";/**
 * 已入库 页签 | 使用统一的 查询表格组件
 *
 * @author FJJ
 * @version 2.0
 *
 *  * History:
 * Date      Version Remarks
 * ========= ======= ======================================================
 * 2022      1.0     First version Zhaoruji  => 备份在 IntoWarhouse.bak.js
 *
 * @copyright 2021-2021, all rights reserved. Essa.cn
 * */
export default class IntoWarhouseTable extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            // 表单 配置
            searchFormOptions:[
                {
                    name:'transitCityIds',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'所有仓库',
                    cnPlaceholderId:'SuoYouCangKu',
                    type:'WarehouseSelect',
                },
                {
                    name:'keyWord',
                    cnTitle:'',
                    cnTitleId:'',
                    cnPlaceholder:'请输入集柜单号或柜号',
                    cnPlaceholderId:'QingShuRuJiGuiDanHaoHuoGuiHao',
                    // type:'SearchInput',
                    width:256,
                },
            ],
            columns:[
                {
                    cnTitle: '集柜单号',
                    dataIndex: 'code',
                    cnTitleId: 'JiGuiDanHao',
                    render:(code, record, index) => (<>
                        <p className={"black89 font-bold"}>{code}</p>
                        {code&&<div>
                            <LogisticsAndCabinetSwitch showContainerCode = {false}
                                                       showPoOutInfo={false}
                                                       poId = {record.poId}
                                                       poCode={record.poCode}
                                                       containerCode={record.code}
                                                       cabinetNum={record.cabinetNum}
                                                       logisticsData={record.pubOrderTrackVOS} />
                        </div>}
                    </>)
                },
                {
                    cnTitle: '订单数',
                    dataIndex: 'orderNumCount',
                    cnTitleId: 'DingDanShu',
                },
                {
                    cnTitle: '商品信息',
                    dataIndex: 'poCreateTime',
                    cnTitleId: 'ShangPinXinXi',
                    render:  (text, record, index) => (
                        <span>{record.skuNum}{Lang({id:'Kuan', default:'款'})}，{record.quantity}{Lang({id: 'Xiang', default: '箱'})}</span>
                    )
                },
                {
                    cnTitle: '总体积m³',
                    dataIndex: 'volume',
                    cnTitleId: 'ZongTiJiM3',
                    render: (totalVolume, record) => <span className="content-text">{toFixedWithCommas(totalVolume, 3) || "-"}</span> //{" "}m³
                },
                {
                    cnTitle: '目的仓库',
                    cnTitleId: 'MuDiCangKu',
                    dataIndex: 'transitCityName',
                },
                {
                    cnTitle: '时间',
                    cnTitleId: 'ShiJian',
                    dataIndex: 'time',
                    // sorter: true,
                    // sorterCustom:(data,sOrder)=>{
                    //     data.orderByPreArrivalPortDate = sOrder === "ascend" ? '2' : '1';
                    //     return data
                    // }, // 1:倒序, 2:正序
                    // sortDirections: ['ascend', 'descend'],
                    render:(text, record, index) => (<>
                        <p>
                            <Tooltip placement="left" title={Lang({id: 'ZhuangGuiFaYunShiJian', default: '装柜发运时间'})}>
                                <i className="ri-truck-line mr_6 black33"></i>{record.loadDate ? dayjs(record.loadDate).format('YYYY-MM-DD') : '-'}
                            </Tooltip>
                        </p>
                        <p>
                            <Tooltip placement="left" title={Lang({id: 'YuJiDaoGangShiJian', default: '预计到达时间'})}>
                                <i className="ri-map-pin-line mr_6 color-green"></i>{record.preArrivalPortDate?dayjs(record.preArrivalPortDate).format('YYYY-MM-DD'):'-'}
                            </Tooltip>
                        </p>
                        <p>
                            <Tooltip placement="left" title={Lang({id: 'RuKuShiJian', default: '入库时间'})}>
                                <i className="ri-calendar-check-line mr_6 color-green"></i>{record.intoWarehouseDate?dayjs(record.intoWarehouseDate).format('YYYY-MM-DD'):'-'}
                            </Tooltip>
                        </p>
                    </> )
                },
            ],
        }
    }
    onRefTabOne = (ref) =>  this.onPageTemplateTableChild = ref;
    onRefPageCommon = (ref) => this.onRefPageCommonChild = ref;
    // 查询回调
    fetchCallBack(res){
        this.onRefPageCommonChild.isShowTop()
    }
    componentDidMount() {
    }
    render() {
        const { columns,searchFormOptions,loading } = this.state;
        return (<Spin spinning={loading}>
            <PageCommon onRef={this.onRefPageCommon}>
            <AutoFetchTable columns={columns}
                            fetchCallBack={(data)=>this.fetchCallBack(data)}
                            onRef={this.onRefTabOne}
                            flagShowReset={false}
                            pageSize={50}
                            // precondition={{
                            //     orderByIntoWarehouseDate:"1",
                            //     orderByPreArrivalPortDate:"2"
                            // }}
                            searchFormOptions={searchFormOptions}
                            fetchApi={'/service/mg/warehouse-management/into-warehouse-list'} />
            </PageCommon>
        </Spin>)
    }
}
